import {
  Scoreboard,
  ScoreboardParticipant,
  ScoreboardParticipants,
  ScoreboardScore,
  ScoreboardScores
} from '@ps/isp-web-component-library';
import type { EnrichedParticipants, EventId } from '@ps/isp-web-services-types';
import type { SnookerFixture } from '@ps/web-shared-generated-graphql/sports';
import React from 'react';

import { EventTypeId } from '@swf/sports/types/eventType';
import { getScoreCharacterLength } from '@swf/sports/utils/getScoreCharacterLength';

import ScoreboardWrapper from '../ScoreboardWrapper/ScoreboardWrapper';

interface Props {
  enrichedParticipants?: EnrichedParticipants;
  eventId: EventId;
  eventTime: string;
  snookerFixture?: SnookerFixture;
}

const getParticipantScore = (
  participant: EnrichedParticipants[number],
  score: SnookerFixture['score'] | undefined
) => (participant.type === 'HOME' ? score?.home : score?.away);

const Snooker: React.FC<Props> = ({ enrichedParticipants, snookerFixture, eventId, eventTime }) => {
  const [participantA, participantB] = enrichedParticipants ?? [];

  const currentScore = participantA.type && participantB.type ? snookerFixture?.score : null;

  return (
    <ScoreboardWrapper eventId={eventId} eventTime={eventTime} eventTypeId={EventTypeId.SNOOKER}>
      <Scoreboard>
        <ScoreboardParticipants>
          <ScoreboardParticipant name={participantA.participant} />
          <ScoreboardParticipant name={participantB.participant} />
        </ScoreboardParticipants>
        <ScoreboardScores>
          <ScoreboardScore
            score={[
              getParticipantScore(participantA, currentScore) ?? null,
              getParticipantScore(participantB, currentScore) ?? null
            ]}
            scoreCharacterLength={getScoreCharacterLength(EventTypeId.SNOOKER, [
              currentScore?.home ?? 0,
              currentScore?.away ?? 0
            ])}
          />
        </ScoreboardScores>
      </Scoreboard>
    </ScoreboardWrapper>
  );
};

export default Snooker;
